function MatchHeight(){
    $('.eq-collection-item .eq-product__title h2').matchHeight({
        byRow: true,
    });
}

$(document).ready(function () {

    /***********************************************/
    /**************** Navigation Menu *************/
    /*********************************************/
    let BREAKPOINT = 992;
    const $body = $("body");
    const $menu = $("#mobile-menu");
    const $nav = $(".nav");

    let panelStack = [];

    // ==========================
    // OPEN MENU
    // ==========================
    $(".js-open-menu").on("click", function (e) {
        e.preventDefault();
        $menu.addClass("active");
        $body.addClass("menu-open overflow-hidden");
        $(".menu-toggle").addClass("open");
        checkHeaderOffset(); // ensure correct position
    });

    // ==========================
    // CLOSE MENU
    // ==========================
    function closeMenu() {
        $menu.removeClass("active");
        $body.removeClass("menu-open overflow-hidden");
        $(".menu-toggle").removeClass("open");
        $(".mega-menu").removeClass("active prev");
        panelStack = [];
    }

    $(".js-close-menu").on("click", closeMenu);

    // ==========================
    // ESC CLOSE
    // ==========================
    $(document).on("keyup", function (e) {
        if (e.key === "Escape") closeMenu();
    });

    // ==========================
    // OUTSIDE CLICK
    // ==========================
    $(document).on("click", function (e) {
        if ($body.hasClass("menu-open")) {
            if (!$(e.target).closest("#mobile-menu, .menu-toggle").length) {
                closeMenu();
            }
        }
    });

    // ==========================
    // MULTI LEVEL PANEL
    // ==========================
    $(".has-mega > a").on("click", function (e) {
        if ($(window).width() < BREAKPOINT) {
            e.preventDefault();
            const $current = $(this).closest(".mega-menu");
            const $next = $(this).siblings(".mega-menu");
            if (!$next.length) return;
            if ($current.length) {
                $current.addClass("prev");
                panelStack.push($current);
            }
            $next.addClass("active");
        }
    });

    // ==========================
    // DESKTOP HOVER
    // ========================== 

    $(".category-title").on("mouseenter", function () {
        if (!window.matchMedia("(min-width: 992px)").matches) return;
        const target = $(this).data("target");
        if (!target) return;
        $(".category-title").removeClass("active");
        $(this).addClass("active");
        $(".mega-panel").removeClass("active");
        $("#" + target).addClass("active");
    });

    // $(document).ready(function () {
    //     if (window.matchMedia("(min-width: 992px)").matches) {
    //         const $default = $('.category-title[data-target="best"]');
    //         $default.addClass("active");
    //         $(".mega-panel").removeClass("active");
    //         $("#best").addClass("active");
    //     }
    // });

    // ==========================
    // HEADER OFFSET (FINAL FIX)
    // ==========================
    function checkHeaderOffset() {
        const header = document.querySelector(".header");
        const announcement = document.querySelector(".announcement-bar");
        let headerHeight = header ? header.offsetHeight : 0;
        let announcementHeight = 0;
        if (announcement) {
            const rect = announcement.getBoundingClientRect();
            // ONLY include if visible in viewport
            if (rect.bottom > 0) {
                announcementHeight = rect.height;
            }
        }
        const total = headerHeight + announcementHeight;
        document.documentElement.style.setProperty("--header-offset", total + "px");
    }
    // Run only when needed (NOT on scroll)
    $(window).on("load resize", checkHeaderOffset);

    // ==========================
    // Mobile Submenu Accordion
    // ==========================
    $(document).ready(function () {

        const duration = 300;

        // ==========================
        // LEVEL 1 (MAIN)
        // ==========================
        $(".mobile-menu__link").on("click", function (e) {

            const $parent = $(this).closest(".js-accordion-item");
            const $content = $parent.children(".js-accordion-content");

            if (!$content.length) return;

            e.preventDefault();

            if ($content.is(":visible")) {

                $content.stop(true, true).slideUp(duration);
                $parent.removeClass("is-open");

            } else {

                // close ONLY main siblings
                $parent.siblings(".js-accordion-item")
                    .find("> .js-accordion-content:visible")
                    .each(function () {
                        $(this).stop(true, true).slideUp(duration)
                            .closest(".js-accordion-item")
                            .removeClass("is-open");
                    });

                $content.stop(true, true).slideDown(duration);
                $parent.addClass("is-open");
            }
        });

        // ==========================
        // LEVEL 2 (SUB MENU)
        // ==========================
        $(".js-sub-accordion-header").on("click", function (e) {
            if (!window.matchMedia("(max-width: 1024px)").matches) return;
            e.preventDefault();

            const $parent = $(this).closest(".js-sub-accordion-item");
            const $content = $parent.children(".js-sub-accordion-content").length > 0 ? $parent.children(".js-sub-accordion-content") : $(this).next(".js-sub-accordion-content");
            if (!$content.length) return;

            if ($content.is(":visible")) {
                $content.stop(true, true).slideUp(duration);
                $parent.removeClass("is-open");
            } else {

                // close siblings only
                $parent.siblings(".js-sub-accordion-item")
                    .find("> .js-sub-accordion-content:visible")
                    .each(function () {
                        $(this).stop(true, true).slideUp(duration)
                            .closest(".js-sub-accordion-item")
                            .removeClass("is-open");
                    });
                $content.stop(true, true).slideDown(duration);
                $parent.addClass("is-open");
            }
        });
    });

    // ==========================
    // STOP on desktop Accordion
    // ==========================
    $(document).on("click", ".js-accordion-header", function (e) {

        // ❌ STOP on desktop
        if (window.matchMedia("(min-width: 992px)").matches) return;

        const $parent = $(this).closest(".js-accordion-item");
        const $content = $parent.children(".js-accordion-content");

        if ($content.is(":visible")) {
            // slideUp($content, $parent);
        } else {

            $(".js-accordion-content:visible").each(function () {
                slideUp($(this), $(this).closest(".js-accordion-item"));
            });

            slideDown($content, $parent);
        }
    });

    $(".shop-megamenu, .mega-menu").hover(
        function () {
            $("body").addClass("is-megamenu-open");
        },
        function () {
            $("body").removeClass("is-megamenu-open");
        }
    );


    // ==========================
    // USP Bar Slider
    // ==========================
    function updateSliderState(swiperInstance2, sliderElement) {
        let section;
        if (
            sliderElement.classList.contains("product-gift-slider") ||
            sliderElement.classList.contains("js-video-work-slider") ||
            sliderElement.classList.contains("how-it-work__row")
        ) {
            section = sliderElement.parentNode;
        } else {
            section = sliderElement.closest("section");
        }
        if (!swiperInstance2 || !section) return;
        let totalSlides = swiperInstance2.slides.length;
        let slidesVisible = 1;
        if (typeof parseInt(swiperInstance2.params.slidesPerView) === "number") {
            slidesVisible = parseInt(swiperInstance2.params.slidesPerView);
        }
        let breakpoints = swiperInstance2.params.breakpoints;
        if (breakpoints) {
            let windowWidth = window.innerWidth;
            Object.keys(breakpoints).forEach((bp) => {
                if (windowWidth >= parseInt(bp)) {
                    let bpSlides = parseInt(breakpoints[bp].slidesPerView);
                    if (typeof bpSlides === "number") {
                        slidesVisible = bpSlides;
                    }
                }
            });
        }
        if (totalSlides <= slidesVisible && slidesVisible !== null) {
            if (section.classList.contains("has-slider-controls")) {
                section.classList.remove("has-slider-controls");
            }
            if (
                sliderElement.classList.contains("js-uspa-slider") &&
                sliderElement.classList.contains("enable-divider") &&
                sliderElement.classList.contains("visible-last-divider")
            ) {
                sliderElement.classList.remove("visible-last-divider");
            }
        } else {
            section.classList.add("has-slider-controls");
            if (
                sliderElement.classList.contains("js-uspa-slider") &&
                sliderElement.classList.contains("enable-divider") &&
                !sliderElement.classList.contains("visible-last-divider")
            ) {
                sliderElement.classList.add("visible-last-divider");
            }
        }
    }
    // ===========================================
    // INIT SWIPER
    // ===========================================
    let uspaSwiperslider = document.querySelectorAll(".js-uspa-slider");
    if (uspaSwiperslider.length > 0) {
        uspaSwiperslider.forEach((currentUspaSwiperslider) => {
            if (currentUspaSwiperslider.swiper) {
                currentUspaSwiperslider.swiper.update();
            } else {
                new Swiper(currentUspaSwiperslider, {
                    slidesPerView: parseFloat(
                        currentUspaSwiperslider.getAttribute("data-slide-mobile")
                    ) || 1.8,
                    spaceBetween: 10,
                    autoplay: {
                        delay: 0
                    },
                    speed: 6000,
                    loop: true,
                    freeMode: false,
                    pagination: false,
                    breakpoints: {
                        768: {
                            slidesPerView: parseFloat(
                                currentUspaSwiperslider.getAttribute("data-slide-tablet")
                            ) || 2
                        },
                        992: {
                            slidesPerView: parseFloat(
                                currentUspaSwiperslider.getAttribute("data-slide-desktop")
                            ) || 4
                        }
                    },
                    on: {
                        init: function () {
                            updateSliderState(this, currentUspaSwiperslider);
                        },
                        resize: function () {
                            updateSliderState(this, currentUspaSwiperslider);
                        }
                    }
                });
            }
        });
    }

    // ==========================
    // Product Tab Slider
    // ========================== 
    // TAB SWIPER (no change)
    const swiperTab = new Swiper(".sliderTab", {
        slidesPerView: 6,
        freeMode: true,
        observer: true,
        observeParents: true,
        breakpoints: {
            0: { slidesPerView: 2.5, spaceBetween: 10 },
            576: { slidesPerView: 3, spaceBetween: 10 },
            768: { slidesPerView: 3.5 },
            992: { slidesPerView: 6 }
        }
    });

    // ===========================================
    // CENTER TAB (no change)
    // ===========================================
    const muCenter = (target) => {
        const snbwrap = document.querySelector(".sliderTab .swiper-wrapper");
        const box = document.querySelector(".sliderTab");
        const boxHalf = box.clientWidth / 2;
        const targetPos = target.offsetLeft + target.clientWidth / 2;
        const pos = targetPos - boxHalf;

        const minPos = 0;
        const maxPos = snbwrap.scrollWidth - box.clientWidth;

        snbwrap.style.transition = "transform 0.25s";
        snbwrap.style.transform = `translate3d(${Math.min(Math.max(pos, minPos), maxPos) * -1}px, 0, 0)`;
    };

    // ===========================================
    // MULTIPLE CONTENT SWIPERS (IMPORTANT CHANGE)
    // ===========================================
    const contentSliders = [];

    document.querySelectorAll(".sliderContent .swiper-container").forEach((el, i) => {
        contentSliders[i] = new Swiper(el, {
            slidesPerView: 4,
            spaceBetween: 16,
            loop: false,
            allowTouchMove: true,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                0: { slidesPerView: 1.2 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 }
            }
        });
    });

    // ==========================
    // TAB CLICK (MAIN FIX)
    // ==========================
    const tabs = document.querySelectorAll(".sliderTab .swiper-slide.tab-div");
    const contents = document.querySelectorAll(".sliderContent");

    tabs.forEach((tab, idx) => {
        tab.addEventListener("click", (e) => {
            e.preventDefault();

            // Remove all active
            tabs.forEach(t => t.classList.remove("on"));

            // Add active to clicked
            tab.classList.add("on");

            // Switch content
            contents.forEach(c => c.classList.remove("active"));
            contents[idx].classList.add("active");

            // Update swiper properly
            contentSliders[idx].update();

            // Center tab
            muCenter(tab);
        });
    });

    // ==========================
    // FAQ Accordion
    // ========================== 
    function faqAccordion() {
        $(".faq-question").click(function () {
            let item = $(this).closest(".faq-item");
            let answer = item.find(".faq-answer");
            if (item.hasClass("active")) {
                answer.stop(true, true).slideUp(400);
                item.removeClass("active");
            } else {
                $(".faq-answer").stop(true, true).slideUp(400);
                $(".faq-item").removeClass("active");
                answer.stop(true, true).slideDown(400);
                item.addClass("active");
            }
        });
    }
    faqAccordion();

    // ==========================
    // After Before
    // ========================== 
    $(window).on("load", function () {
        $("#before_after").twentytwenty({
            default_offset_pct: 0.5,
            orientation: "horizontal",
            no_overlay: true
        });
    });
    // ==========================
    // Mobile PDP Thumb Slider
    // ========================== 
    // Thumbnail slider
    var thumbSwiper = new Swiper(".product-thumb-slider", {
        spaceBetween: 5,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".thumb-next",
            prevEl: ".thumb-prev",
        },
    });

    // Main slider
    var mainSwiper = new Swiper(".product-main-slider", {
        spaceBetween: 10,
        navigation: {
            nextEl: ".main-next",
            prevEl: ".main-prev",
        },
        thumbs: {
            swiper: thumbSwiper,
        },
    });

    // ==========================
    // Announcement bar Slider
    // ========================== 


    function setEqualHeight(swiper) {
        const slides = swiper.el.querySelectorAll('.swiper-slide');
        let maxHeight = 0;

        // reset heights
        slides.forEach(slide => {
            slide.style.height = 'auto';
        });

        // calculate tallest
        slides.forEach(slide => {
            if (slide.offsetHeight > maxHeight) {
                maxHeight = slide.offsetHeight;
            }
        });

        // apply height
        slides.forEach(slide => {
            slide.style.height = maxHeight + 'px';
        });
    }

    var announcementBar = new Swiper(".eq-announcement-bar .swiper", {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        autoplay: false,
        navigation: {
            nextEl: ".eq-announcement-bar .swiper-button-next",
            prevEl: ".eq-announcement-bar .swiper-button-prev"
        },
        on: {
            init: function () {
                setEqualHeight(this);
            },
            resize: function () {
                setEqualHeight(this);
            },
            imagesReady: function () {
                setEqualHeight(this);
            }
        }
    });




    /******************************************/
    /**************** Move to top *************/
    /******************************************/
    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 100) {
            $('.scroll-top').addClass('visible');
        } else {
            $('.scroll-top').removeClass('visible');
        }
    });
    $(".scroll-top").on("click", function () {
        $("html, body").animate({ scrollTop: 0 }, 600);
    });

    
    initCollectionFilters();

    setTimeout(() => {
        
        const urlParams = new URLSearchParams(window.location.search);
        const currentSort = urlParams.get("sort_by");
        
        // If no sorting exists in URL
        if (!currentSort) {
            
            // Trigger default sorting
            // $(".dropdown__select-option[data-value='best-selling']").trigger("click");
            
        }
    }, 500);

    function initCollectionFilters() {

        const filterWrapper = document.querySelector('.eq-collection-filter .eq-collection-filter-value');

        if (!filterWrapper) return;
        // const activeSortValue = $(".dropdown__select-option.active").data("value");
        const activeSortValue =
            new URL(window.location.href).searchParams.get("sort_by") ||
            $(".dropdown__select-option.active").data("value");

        /*
        =========================
        FILTER CHECKBOXES
        =========================
        */

        const filterInputs = filterWrapper.querySelectorAll(
            'input[type="checkbox"]'
        );

        filterInputs.forEach((input) => {

            input.addEventListener('change', () => {
                applyCollectionFilters();
            });

        });

        document.querySelectorAll('.eq-collection-filter-value .collection-item').forEach(item => {
            const group = item.querySelector('.checkbox__group');
            // console.log(group, group.innerHTML)
            if (group && !group.innerHTML.trim()) {
                item.style.display = 'none';
            }
        });

        /*
        =========================
        SORTING
        =========================
        */

        const sortSelect = document.getElementById('SortBy');

        if (sortSelect) {
            setTimeout(() => {
                
                $(".dropdown__select-option").removeClass("active");
                $(".dropdown__select-option[data-value='" + activeSortValue + "']")
                .addClass("active");

                const activeText = $(".dropdown__select-option.active").text().trim();

                $(".dropdown__filter-selected .sort-value").text(activeText);

                // Add sort_by if missing
                const url = new URL(window.location.href);

                if (!url.searchParams.has('sort_by')) {
                    url.searchParams.set('sort_by', activeSortValue);

                    window.history.replaceState({}, '', url.toString());
                }

                MatchHeight();
                if (window.okeWidgetApi) {
                        document
                        .querySelectorAll('[data-oke-star-rating]')
                        .forEach((holder) => {
                            if (!holder.innerHTML.trim()) {
                                window.okeWidgetApi.initWidget(holder, true);
                            }
                        });
                }

            }, 300);

        //     sortSelect.addEventListener('change', () => {
        //     applyCollectionFilters();
        //     });

        }

        const clearButton = document.getElementById('ClearAllFilters');

        // if (!clearButton) return;

        clearButton.addEventListener('click', async (e) => {

            e.preventDefault();
            /*
            =========================
            CLEAN URL
            =========================
            */

            const currentParams_init = new URLSearchParams(window.location.search);
            const cleanUrl = window.location.pathname;

            try {

                document.body.classList.add('loading');

                const response = await fetch(cleanUrl);

                const responseText = await response.text();

                const html = new DOMParser().parseFromString(
                    responseText,
                    'text/html'
                );

                /*
                =========================
                REPLACE SECTION
                =========================
                */

                const newCollectionSection =
                    html.querySelector('.eq-collection-filter');

                if (newCollectionSection) {

                    document.querySelector('.eq-collection-filter').innerHTML =
                        newCollectionSection.innerHTML;

                }

                /*
                =========================
                UPDATE URL
                =========================
                */

                window.history.pushState(
                    {},
                    '',
                    cleanUrl
                );

                /*
                =========================
                REINIT
                =========================
                */

                initCollectionFilters();

                // Sort by function
                sortByFun();
                initPriceSlider();
                //   initClearFilters();

                // setTimeout(() => {
                    
                //     const urlParams = new URLSearchParams(window.location.search);
                //     const currentSort = urlParams.get("sort_by");

                //     // If no sorting exists in URL
                //     if (!currentSort) {

                //         // Trigger default sorting
                //         // $(".dropdown__select-option[data-value='best-selling']").trigger("click");

                //     }
                // }, 500);

            } catch (error) {

                console.log(error);

            } finally {

                document.body.classList.remove('loading');

            }

        });
        

    }

    async function applyCollectionFilters() {
        const filterWrapper = document.querySelector('.eq-collection-filter');

        if (!filterWrapper) return;

        const params = new URLSearchParams();

        const currentParams = new URLSearchParams(window.location.search);

        /*
        =========================
        CHECKBOX FILTERS
        =========================
        */

        Array.from(currentParams.keys()).forEach((key) => {

            if (
                key.startsWith("filter.") ||
                key === "filter.v.availability" ||
                key === "filter.p.vendor" ||
                key === "filter.v.price.gte" ||
                key === "filter.v.price.lte"
            ) {
                currentParams.delete(key);
            }

        });



        const checkedInputs = filterWrapper.querySelectorAll(
            'input[type="checkbox"]:checked'
        );

        checkedInputs.forEach((input) => {

            params.append(
                input.name,
                input.value
            );

        });

        params.forEach((value, key) => {

            currentParams.append(key, value);

        });

        /*
        =========================
        FINAL URL
        =========================
        */

        const collectionUrl =
            `${window.location.pathname}?${currentParams.toString()}`;

        // const activeSortValue = $(".dropdown__select-option.active").data("value");
        /*
        Example:
        /collections/all?
        filter.p.t.category=aa-1-1-1&
        filter.v.option.size=Small&
        filter.p.product_type=SeaDrift+Pants&
        sort_by=title-ascending
        */

        try {

            document.body.classList.add('loading');

            
            // setTimeout(() => {
            const response = await fetch(collectionUrl);
            const responseText = await response.text();

            const html = new DOMParser().parseFromString(
                responseText,
                'text/html'
            );

            /*
            =========================
            REPLACE ENTIRE SECTION
            =========================
            */

            const newFilterSection =
                html.querySelector('.eq-collection-filter');

            if (newFilterSection) {

                document.querySelector('.eq-collection-filter').innerHTML =
                    newFilterSection.innerHTML;

            }

            /*
            =========================
            UPDATE URL
            =========================
            */

            window.history.pushState(
                {},
                '',
                collectionUrl
            );

            /*
            =========================
            RE-INIT EVENTS
            =========================
            */
            initCollectionFilters();

        } catch (error) {

            console.log('Collection filter error:', error);

        } finally {

            document.body.classList.remove('loading');

        }

        // Sort by function
        sortByFun();
        initPriceSlider();
    }

    function sortByFun() {
        const $dropdown = $(".eq-collection-prod-filter");
        const $switchInput = $dropdown.find(".dropdown__switch");

        // Close dropdown on outside click
        $(document).on("click", function (e) {
            if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
                $switchInput.prop("checked", false);
            }
        });

        const $collectionSelected = $(".dropdown__filter-selected .sort-value");
        const $sortBySelect = $("#SortBy");
        const $customOptions = $(".dropdown__select-option");
        const $collectionWrapper = $(".eq-collection-filter");
        const $productGridContainer = $("#ProductGridContainer");

        if ($sortBySelect.length && $collectionSelected.length && $switchInput.length) {

            // Set default active option
            const currentValue = $sortBySelect.val();
            const $activeOption = $customOptions.filter(function () {
                return $(this).data("value") == currentValue;
            });

            if ($activeOption.length) {
                $customOptions.removeClass("active");
                $activeOption.addClass("active");
                $collectionSelected.text($activeOption.text());
            }

            // Option click
            $customOptions.on("click", function () {
                const value = $(this).data("value");

                // $sortBySelect.val(value).trigger("change");
                $collectionSelected.text($(this).text());

                $customOptions.removeClass("active");
                $(this).addClass("active");


            const activeSortValue = value;
                // -----------------------------------
                // Build URL with dynamic sort value
                // -----------------------------------
                let currentUrl = window.location.pathname;
                let searchParams = new URLSearchParams(window.location.search);

                // Set sort_by dynamically
                searchParams.set("sort_by", value);

                // Final URL
                const finalUrl = `${currentUrl}?${searchParams.toString()}`;

                // -----------------------------------
                // AJAX Replace Collection
                // -----------------------------------
                $.ajax({
                    url: finalUrl,
                    type: "GET",
                    success: function (response) {

                        // Get updated collection HTML
                        const newHtml = $(response).find("#ProductGridContainer").html();
                        // const sortSelectedValue = $(response).find("#SortBy").val();

                        setTimeout(function () {
                            window.history.pushState({}, '', finalUrl); 
                            // $sortBySelect.val(value).trigger("change");
                            $productGridContainer.html(newHtml);
                            // $sortBySelect.val(sortSelectedValue).trigger("change");
                            $collectionSelected.text($(this).text());
                        }, 100);


                        setTimeout(() => {
                        
                        $(".dropdown__select-option").removeClass("active");
                        $(".dropdown__select-option[data-value='" + activeSortValue + "']")
                        .addClass("active");

                        const activeText = $(".dropdown__select-option.active").text().trim();

                        $(".dropdown__filter-selected .sort-value").text(activeText);

                        // Add sort_by if missing
                        const url = new URL(window.location.href);

                        if (!url.searchParams.has('sort_by')) {
                            url.searchParams.set('sort_by', activeSortValue);

                            window.history.replaceState({}, '', url.toString());
                        }

                    }, 300);

                        initPriceSlider();
                        // Optional:
                        // Update browser URL without reload

                    },
                    error: function (xhr, status, error) {
                        console.log("Sort Error:", error);
                    }
                });

            });

            // Close dropdown after change
            $sortBySelect.on("change", function () {
                setTimeout(function () {
                    $switchInput.prop("checked", false);
                }, 0);
            });

            // Extra safety: close if clicked outside generic dropdown
            $(document).on("click", function (e) {
                const $genericDropdown = $(".dropdown");
                if ($genericDropdown.length && !$genericDropdown.is(e.target) && $genericDropdown.has(e.target).length === 0) {
                    $switchInput.prop("checked", false);
                }
                // sortByFun();
            });
        }
    }

    // Sort by function
    sortByFun();

    // ==========================
    // COLLECTION TAB CLICK 
    // ==========================
    //    $(".eq-collection__category a").on("click", function (e) {
    //        e.preventDefault();

    //        let category = $(this).data("category");

    //        // Active tab
    //        $(".eq-collection__category a").removeClass("active");
    //        $(this).addClass("active");

    //        // Show correct content
    //        $(".eq-product__sub").removeClass("active").hide();
    //        $('.eq-product__sub[data-category="' + category + '"]')
    //            .addClass("active")
    //            .fadeIn(200);

    //         // $('#ClearAllFilters').click();
    //    });


    const $collectionWrapper = $(".eq-collection-filter");

    function initPriceSlider() {

        const $fromSlider = $("#fromSlider");
        const $toSlider = $("#toSlider");

        const $fromTooltip = $("#fromSliderTooltip");
        const $toTooltip = $("#toSliderTooltip");

        const $fill = $(".range-fill").length
            ? $(".range-fill")
            : $("<div class='range-fill'></div>").appendTo(".sliders_control");

        function updateUI() {

            let from = parseInt($fromSlider.val());
            let to = parseInt($toSlider.val());

            if (from > to) {
                [from, to] = [to, from];
            }

            const min = parseInt($fromSlider.attr("min"));
            const max = parseInt($fromSlider.attr("max"));

            const percentFrom = ((from - min) / (max - min)) * 100;
            const percentTo = ((to - min) / (max - min)) * 100;

            // Fill
            $fill.css({
                left: percentFrom + "%",
                width: (percentTo - percentFrom) + "%"
            });

            // Tooltip
            $fromTooltip.html(`$${from}`);
            $toTooltip.html(`$${to}`);

            $fromTooltip.css("left", percentFrom + "%");
            $toTooltip.css("left", percentTo + "%");

            // Hidden inputs
            $("#minPriceInput").val(from);
            $("#maxPriceInput").val(to);

            
            // sortByFun();

        }

        // ----------------------------
        // AJAX FILTER UPDATE
        // ----------------------------
        function updatePriceFilter() {

        const activeSortValue =
            new URL(window.location.href).searchParams.get("sort_by") ||
            $(".dropdown__select-option.active").data("value");
            let from = parseInt($fromSlider.val());
            let to = parseInt($toSlider.val());

            if (from > to) {
                [from, to] = [to, from];
            }

            // Current URL
            const currentUrl = new URL(window.location.href);

            // Set Shopify price params
            currentUrl.searchParams.set("filter.v.price.gte", from);
            currentUrl.searchParams.set("filter.v.price.lte", to);

            // Optional:
            currentUrl.searchParams.delete("page");

            const finalUrl = currentUrl.toString();

            // AJAX load
            $.ajax({
                url: finalUrl,
                type: "GET",

                success: function (response) {

                    // Replace filter/products section
                    const html = $(response).find(".eq-collection-filter").html();

                    $(".eq-collection-filter").html(html);

                    // Update browser URL
                    window.history.pushState({}, "", finalUrl);

                    // Re-init slider after DOM replace
                    initPriceSlider();

                    // Restore values
                    $("#fromSlider").val(from);
                    $("#toSlider").val(to);

                    $("#minPriceInput").val(from);
                    $("#maxPriceInput").val(to);

                    // Repaint UI
                    $("#fromSlider").trigger("input");

                    initCollectionFilters();
                    // sortByFun();

            //  setTimeout(() => {
                        
            //             console.log('activeSortValue ', activeSortValue);
            //             $(".dropdown__select-option").removeClass("active");
            //             $(".dropdown__select-option[data-value='" + activeSortValue + "']")
            //             .addClass("active");

            //             const activeText = $(".dropdown__select-option.active").text().trim();

            //             $(".dropdown__filter-selected").text(activeText);

            //             // Add sort_by if missing
            //             const url = new URL(window.location.href);

            //             if (!url.searchParams.has('sort_by')) {
            //                 url.searchParams.set('sort_by', activeSortValue);

            //                 window.history.replaceState({}, '', url.toString());
            //             }

            //         }, 500);

                    // setTimeout(() => {
                        // $(".dropdown__select-option[data-value='" + activeSortValue + "']").click();
                        // $('#filter-switch').prop('checked',false)
                    // }, 100);

                }

            });

        }

        // ----------------------------
        // EVENTS
        // ----------------------------

        $fromSlider.off("input").on("input", function () {
            updateUI();
        });

        $toSlider.off("input").on("input", function () {
            updateUI();
        });

        // Apply filter AFTER drag finished
        $fromSlider.off("change").on("change", function () {
            updatePriceFilter();
        });

        $toSlider.off("change").on("change", function () {
            updatePriceFilter();
        });

        // Initial UI
        updateUI();

    }

    // Init first load
    initPriceSlider();


    const clearBtn = document.getElementById('ClearAllFilters');

    if (!clearBtn) return;

    clearBtn.addEventListener('click', async (e) => {

      e.preventDefault();

      /*
      =========================
      PRESERVE SEARCH PARAMS
      =========================
      */

      const currentParams = new URLSearchParams(window.location.search);

      const newParams = new URLSearchParams();

      /*
      Keep search query
      Example:
      ?q=shirt
      */

      if (currentParams.get('q')) {

          newParams.set(
              'q',
              currentParams.get('q')
          );

      }

      /*
      FINAL CLEAN URL
      */

      const cleanUrl =
          `${window.location.pathname}${newParams.toString() ? '?' + newParams.toString() : ''}`;

      try {

          document.body.classList.add('loading');

          const response = await fetch(cleanUrl);

          const responseText = await response.text();

          const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
          );

          /*
          =========================
          REPLACE SECTION
          =========================
          */

          const newCollectionSection =
              html.querySelector('.eq-collection-filter');

          if (newCollectionSection) {

              document.querySelector('.eq-collection-filter').innerHTML =
                  newCollectionSection.innerHTML;

          }

          /*
          =========================
          UPDATE URL
          =========================
          */

          window.history.pushState(
              {},
              '',
              cleanUrl
          );

          /*
          =========================
          REINIT
          =========================
          */

          initCollectionFilters();

      } catch (error) {

          console.log(error);

      } finally {

          document.body.classList.remove('loading');

      }

  });

    MatchHeight();

    });

    /******************************************************/
    /**************** Collection Filter Dropdown *************/
    /******************************************************/
    // $(document).ready(function () {

    function filterMobilePopup() {
        const $filterBtn = $(".mobile-btn-popup");
        const $filterDropdown = $(".eq-collection-filter");
        const $filterContent = $(".eq-collection__left");

        function isMobile() {
            return window.innerWidth <= 991;
        }

        // Toggle filter (ONLY MOBILE)
        $filterBtn.on("click", function (e) {
            if (!isMobile()) return; // ❌ desktop

            e.stopPropagation();

            $filterContent.slideToggle(200);
            $filterDropdown.toggleClass("active");
        });

        // Outside click (ONLY MOBILE)
        $(document).on("click", function (e) {
            if (!isMobile()) return; // ❌ desktop

            if (
                !$filterContent.is(e.target) &&
                $filterContent.has(e.target).length === 0 &&
                !$filterBtn.is(e.target)
            ) {
                $filterContent.slideUp(200);
                $filterDropdown.removeClass("active");
            }
        });
    }
    filterMobilePopup();
    // });

    /******************************************************/
    /**************** Testimonials Slider *************/
    /******************************************************/
    new Swiper(".eq-testimonial-slider", {
        loop: true,
        slidesPerView: 5,
        spaceBetween: 14,

        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },

        breakpoints: {
            0: {
                slidesPerView: 1,
                centeredSlides: false,
            },
            768: {
                slidesPerView: 2,
                centeredSlides: false,
            },
            1024: {
                slidesPerView: 4,
                centeredSlides: true,
            },
        }
    });

    /********************************************/
    /**************** Banner Slider ************/
    /*******************************************/
    new Swiper(".heroBannerSwiper", {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: "fade",

        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },

        breakpoints: {
            0: {
                slidesPerView: 1,
                centeredSlides: false,
            },
            768: {
                slidesPerView: 1,
                centeredSlides: false,
            },
            1024: {
                slidesPerView: 1,
                centeredSlides: true,
            },
        }
    });

    /*****************************************/
    /**************** Mobile Search ************/
    /*****************************************/
    $(".search-btn").click(function () {
        $(".search-box-main").fadeIn();
        $("body").addClass("popup");
    });
    $(".search-close").click(function () {
        $(".search-box-main").fadeOut();
        $("body").removeClass("popup");
    });
    $(".search_button").click(function () {
        $(".search-box-main").fadeIn();
        $("body").addClass("popup");
    });

    /*****************************************/
    /**************** MINI CART *************/
    /****************************************/
    // $(".cart-btn").on("click", function (e) {
    //     e.preventDefault();
    //     $(".mini_cart").fadeIn();
    //     $("body").addClass("cart_open");
    // });

    $(".cart-close").on("click", function () {
        // $(".mini_cart").fadeOut();
        $("body").removeClass("cart_open");
    });
    /* ===== GLOBAL OUTSIDE CLICK ===== */
    $(document).on("click touchend", function (e) {
        if ($(e.target).closest(".mini_cart, .cart-btn").length === 0) {
            // $(".mini_cart").fadeOut();
            $("body").removeClass("cart_open");
        }
    });

    /*****************************************/
    /**************** Size Guide *************/
    /****************************************/
    var fancyboxInitialized = false;
    function initFancybox() {
        // Prevent duplicate binding
        if (fancyboxInitialized) {
            Fancybox.destroy();
        }

        Fancybox.bind("[data-fancybox='size-guide']", {
            Thumbs: { autoStart: true }
        });

        fancyboxInitialized = true;
    }

    // Initial load
    $(document).ready(function () {
        initFancybox();
    });

    // Shopify section reload
    $(document).on("shopify:section:load", function () {
        initFancybox();
    });

    $(document).on("shopify:section:select", function () {
        initFancybox();
    });


    /*****************************************/
    /**************** Product QTY ************/
    /*****************************************/
    $('.product-plus').click(function (e) {
        e.preventDefault();
        var quantity = parseInt($('#productcolor').val());
        $('#productcolor').val(quantity + 1);
    });
    $('.product-minus').click(function (e) {
        e.preventDefault();
        var quantity = parseInt($('#productcolor').val());
        if (quantity > 0) {
            $('#productcolor').val(quantity - 1);
        }
    });

    /****************************************************/
    /**************** Product Thumb Slider *************/
    /****************************************************/
    function pdpSliderImages() {
        document.querySelectorAll(".eq-pdp-product__slider").forEach((slider) => {
            const mainEl = slider.querySelector(".product-main-slider");
            const thumbEl = slider.querySelector(".product-thumb-slider");
            const nextEl = slider.querySelector(".main-next");
            const prevEl = slider.querySelector(".main-prev");

            if (!mainEl || !thumbEl) return;

            const thumbSwiper = new Swiper(thumbEl, {
                spaceBetween: 8,
                slidesPerView: 4,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                breakpoints: {
                    768: {
                        slidesPerView: 5,
                    },
                    1024: {
                        slidesPerView: 6,
                    }
                }
            });

            new Swiper(mainEl, {
                spaceBetween: 10,
                loop: true,
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl,
                },
                thumbs: {
                    swiper: thumbSwiper,
                },
            });

        });
    }
    pdpSliderImages();

    /*********************************************************/
    /**************** Adventure Starts With Gear *************/
    /*********************************************************/
    var $drawer = $("#Product-Drawer");
    var $content = $("#Product-Drawer-Content");
    var $body = $("body");

    /* =========================
       FULL HTML PER PRODUCT
    ========================= */
    function getProductTemplate(data) {
        return `
         <div class="eq-pdp__wrapper eq-pdp__content">

        <!-- LEFT -->
        <div class="eq-pdp__left">
            <div class="eq-pdp_thumb__media">

                <div class="eq-pdp-thumb__gallery grid-gallery">
                    ${data.images.map((img, index) => `
                        <div class="eq-pdp-thumb_gallery__img ${index === 1 ? 'big' : ''}">
                            <a data-fancybox="gallery" href="${img}">
                                <img src="${img}" alt="">
                            </a>
                        </div>
                    `).join("")}
                </div>

            </div>
        </div>

        <!-- RIGHT (UNCHANGED) -->
        <div class="eq-pdp__right">
            <div class="eq-pdp__details">

                <div class="eq-pdp__review">
                    <img src="https://cdn.shopify.com/s/files/1/0744/1835/files/pdp-review-icon.svg?v=1777284189" alt="">
                    <span>1,185&nbsp;Reviews</span>
                </div>

                <div class="eq-pdp__title">
                    <h1>${data.title}</h1>
                </div>

                <div class="eq-pdp__lists">
                    <ul>
                        <li>Durable, high-quality gear you trust</li>
                        <li>Exclusive deals on top-rated products</li>
                        <li>Ready for any outdoor challenge</li>
                    </ul>
                </div>

                <div class="eq-pdp_color__swatch">
                    <div class="eq-pdp_color_swatch__title">
                        <label>
                            <span>Colors:</span>
                            <span class="txt-bold">Ironwood</span>
                        </label>
                    </div>
                    <div class="eq-pdp_color_swatch__options">
                        <ul>
                            <li class="active">
                                <a href="#"><img src="https://cdn.shopify.com/s/files/1/0744/1835/files/pdp-color-swatch-01.png?v=1777283956"></a>
                            </li>
                            <li>
                                <a href="#"><img src="https://cdn.shopify.com/s/files/1/0744/1835/files/pdp-color-swatch-02.png?v=1777283956"></a>
                            </li>
                            <li>
                                <a href="#"><img src="https://cdn.shopify.com/s/files/1/0744/1835/files/pdp-color-swatch-03.png?v=1777283956"></a>
                            </li>
                            <li>
                                <a href="#"><img src="https://cdn.shopify.com/s/files/1/0744/1835/files/pdp-color-swatch-04.png?v=1777283957"></a>
                            </li>
                            <li>
                                <a href="#"><img src="https://cdn.shopify.com/s/files/1/0744/1835/files/pdp-color-swatch-05.png?v=1777283956"></a>
                            </li>
                            <li>
                                <a href="#"><img src="https://cdn.shopify.com/s/files/1/0744/1835/files/pdp-color-swatch-06.png?v=1777283956"></a>
                            </li>
                            <li>
                                <a href="#"><img src="https://cdn.shopify.com/s/files/1/0744/1835/files/pdp-color-swatch-07.png?v=1777283956"></a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="eq-pdp_size__option">
                    <div class="eq-pdp_size__title">
                        <label>
                            <span>Select Size</span>
                        </label>
                    </div>
                    <div class="eq-pdp_size__options">
                        <button class="disable">S</button>
                        <button>M</button>
                        <button class="disable">L</button>
                        <button class="active">XL</button>
                        <button>2XL</button>
                        <button>3XL</button>
                        <button>4XL</button>
                        <button>5XL</button>
                    </div>
                </div>

                <div class="eq-pdp_fit__option">
                    <div class="eq-pdp_fit__title">
                        <label>
                            <span>Select Fit</span>
                        </label>
                    </div>
                    <div class="eq-pdp_fits__options">
                        <button class="active">Active Fit</button>
                        <button>Classic Fit</button>
                        <button>Modern Cut</button>
                    <button>Slim Fit</button>
                        <button class="disable">Full Cut</button>
                        <button>Relaxed Cut</button>
                    </div>
                </div>

                <div class="eq-pdp_price">
                    <span class="new_price">${data.price}</span>
                    <span class="old_price">${data.comparePrice || ""}</span>
                    <span class="save_label"><del>SAVE XX%</del></span>
                </div>

                <div class="eq-pdp_instock">
                    <img src="https://cdn.shopify.com/s/files/1/0744/1835/files/pdp-instock-icon.png?v=1777284079">
                    <span>In stock, Expected Delivery Feb XX - Feb XX</span>
                </div>

                <div class="eq-pdp_add_to_cart">
                    <button class="btn btn-primary">ADD TO CART</button>
                </div>

                <div class="eq-pdp_patment__option">
                    <span><img src="https://cdn.shopify.com/s/files/1/0744/1835/files/pdp-secure-icon.svg?v=1777284124"> Guaranteed Secure Checkout</span>
                    <img src="https://cdn.shopify.com/s/files/1/0744/1835/files/pdp-payment-icons.svg?v=1777284157" class="pdp-payment">
                </div>

            </div>
        </div>

    </div>
    `;
    }

    var productsData = {
        "gunmetal-tekcheck-shirt-long-sleeve": {
            title: "Gunmetal TekCheck Shirt",
            price: "$70.00",
            comparePrice: "$83.69",
            images: [
                "https://cdn.shopify.com/s/files/1/0744/1835/files/GunMetal-01.jpg?v=1777283126",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/GunMetal-02.jpg?v=1777283127",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/GunMetal-03.jpg?v=1777283127",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/GunMetal-04.jpg?v=1777283127",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/GunMetal-05.jpg?v=1777283127",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/GunMetal-06.jpg?v=1777283127"
            ]
        },

        "agave-pearl-snap-shirt": {
            title: "Agave Pearl Snap Shirt",
            price: "$65.00",
            comparePrice: "$80.00",
            images: [
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Agave-01.jpg?v=1777283434",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Agave-02.jpg?v=1777283434",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Agave-03.jpg?v=1777283434",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Agave-04.jpg?v=1777283434"
            ]
        },

        "whiskey-original-shirt-long-sleeve": {
            title: "Whiskey Original Shirt",
            price: "$65.00",
            comparePrice: "$80.00",
            images: [
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Whiskey-01.jpg?v=1777283486",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Whiskey-02.jpg?v=1777283486",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Whiskey-03.jpg?v=1777283486",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Whiskey-04.jpg?v=1777283486",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Whiskey-05.jpg?v=1777283486",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Whiskey-06.jpg?v=1777283487",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Whiskey-07.jpg?v=1777283487",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Whiskey-08.jpg?v=1777283487"
            ]
        },

        "caviar-stockyard-shirt-long-sleeve": {
            title: "Caviar StockYard Shirt | Long Sleeve",
            price: "$75.00",
            comparePrice: "$80.00",
            images: [
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-01.jpg?v=1777283566",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-02.jpg?v=1777283566",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-03.jpg?v=1777283566",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-04.jpg?v=1777283566",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-05.jpg?v=1777283566",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-06.jpg?v=1777283566",
            ]
        },

        "caviar-pearl-snap-shirt-long-sleeve": {
            title: "Caviar Pearl Snap Shirt | Long Sleeve",
            price: "$75.00",
            comparePrice: "$80.00",
            images: [
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-Pearl-01.jpg?v=1777283642",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-Pearl-02.jpg?v=1777283641",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-Pearl-03.jpg?v=1777283642",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-Pearl-04.jpg?v=1777283643",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-Pearl-05.jpg?v=1777283642",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-Pearl-06.jpg?v=1777283642",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-Pearl-07.jpg?v=1777283642",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Caviar-Pearl-08.jpg?v=1777283642"
            ]
        },

        "stone-stockyard-shirt-long-sleeve": {
            title: "Stone StockYard Shirt | Long Sleeve",
            price: "$75.00",
            comparePrice: "$80.00",
            images: [
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Stone-01.jpg?v=1777283724",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Stone-02.jpg?v=1777283726",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Stone-03.jpg?v=1777283725",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Stone-04.jpg?v=1777283725",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Stone-05.jpg?v=1777283725",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Stone-06.jpg?v=1777283724",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Stone-07.jpg?v=1777283724",
                "https://cdn.shopify.com/s/files/1/0744/1835/files/Stone-08.jpg?v=1777283724"
            ]
        }
    };

    /* =========================
       OPEN DRAWER
    ========================= */
    function openDrawer(html) {
        $content.html(html);
        // faqAccordion();
        $(".faq-question").click(function () {
            let item = $(this).closest(".faq-item");
            let answer = item.find(".faq-answer");
            if (item.hasClass("active")) {
                answer.stop(true, true).slideUp(400);
                item.removeClass("active");
            } else {
                $(".faq-answer").stop(true, true).slideUp(400);
                $(".faq-item").removeClass("active");
                answer.stop(true, true).slideDown(400);
                item.addClass("active");
            }
        });
        pdpSliderImages();
        $body.addClass("open-cc--product");
        $drawer.addClass("active");
    }

    /* =========================
       CLOSE DRAWER
    ========================= */
    function closeDrawer() {
        $drawer.removeClass("active");
        $body.removeClass("open-cc--product");

        setTimeout(function () {
            $content.html("");
        }, 260);
    }

    /* =========================
       QUICK VIEW CLICK
    ========================= */
    $(document).on("click", ".quick-view", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var handle = $(this).data("product-handle");

        if (!handle) return;

        // var product = productsData[handle];

          $.ajax({
            url: `/products/${handle}`,
            type: "GET",
            success: function (response) {
            const parsedResponse = new DOMParser().parseFromString(response, 'text/html');
            const sectionResponse = parsedResponse.querySelector('product-info');
            openDrawer(sectionResponse);

            // initializeQuickView();
            
            },
            error: function () {

                openDrawer(`
                    <div class="error">
                        Failed to load product.
                    </div>
                `);

            }
        });

        // if (!product) {
        //     console.error("No product data found for:", handle);
        //     return;
        // }

        // var html = getProductTemplate(product);

        // openDrawer(html);

    });

    /* =========================
       OUTSIDE CLICK
    ========================= */
    $(document).on("click", function (e) {
        if (
            $drawer.hasClass("active") &&
            !$drawer.is(e.target) &&
            $drawer.has(e.target).length === 0 &&
            $(".fancybox__container").length === 0 &&
            $(".slidecarthq.open").length === 0
        ) {
            closeDrawer();
        }
    });

    /* =========================
       CLOSE BUTTON
    ========================= */
    $(document).on("click", ".side-panel-close", function (e) {
        e.preventDefault();
        closeDrawer();
    });

    /* =========================
       ESC KEY
    ========================= */
    $(document).on("keyup", function (e) {
        if (e.key === "Escape") {
            closeDrawer();
        }
    });

/******************************************/
/**************** Search Result *************/
/******************************************/
// $(document).ready(function () {

//     const $input = $(".search-box input");
//     const $resultsBox = $("#searchResults");
//     const $items = $("#resultsContainer .eq-product__item");
//     const $count = $(".result-count");
//     const $noResults = $(".no-results");

//     $input.on("input", function () {

//         let query = $(this).val().toLowerCase().trim();
//         let visibleCount = 0;

//         if (query.length > 0) {
//             $resultsBox.show();
//         } else {
//             $resultsBox.hide();
//             return;
//         }

//         $items.each(function () {

//             let title = $(this).find("h2").text().toLowerCase();
//             let badge = $(this).find(".eq-product_list__badge span").text().toLowerCase();

//             if (title.includes(query) || badge.includes(query)) {
//                 $(this).show();
//                 visibleCount++;
//             } else {
//                 $(this).hide();
//             }

//         });

//         if (visibleCount > 0) {
//             $count.text(visibleCount + " results found").show();
//             $noResults.hide();
//             $("#resultsContainer").show();
//         } else {
//             $count.hide();
//             $noResults.show();
//             $("#resultsContainer").hide();
//         }

//     });

//     $(document).on("click", function (e) {
//         if (!$(e.target).closest(".search-box, #searchResults").length) {
//             $resultsBox.hide();
//         }
//     });

// });






let searchInput = document.querySelector('.header-search .search-box input');
let mobileSeatchInput = document.querySelector('.search-box-main .search-box input');
let popup = document.querySelector('.search-box-main');
let resultsWrapper = document.querySelector('#searchResults');
let resultsContainer = document.querySelector('#resultsContainer');
let closeBtn = document.querySelector('.search-close');
let searchResultsWrapper = document.querySelector('.desktop-search-wrapper');
let searchResultsWrapperMobile = document.querySelector('.mobile-search-wrapper');

let debounceTimer;

// OPEN popup
// document.querySelector('.search-box input').addEventListener('focus', () => {
//   popup.style.display = 'block';
// });

// CLOSE popup
// closeBtn.addEventListener('click', () => {
//   popup.style.display = 'none';
//   resultsWrapper.style.display = 'none';
// });

// CLICK OUTSIDE
document.addEventListener('click', (e) => {
    if (!e.target.closest('.header-search')) {
        // popup.style.display = 'none';
        searchResultsWrapper.style.display = 'none';
    }
});

// INPUT EVENT
searchInput.addEventListener('input', function () {
    let searchTerm = this.value.trim();

    clearTimeout(debounceTimer);

    if (searchTerm.length < 1) {
        searchResultsWrapper.style.display = 'none';
        return;
    }

    debounceTimer = setTimeout(() => {

        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[options][fields]=title,body,product_type,variants.title,vendor,variants.sku&resources[limit]=5&section_id=predictive-search`)
            .then(res => res.text())
            .then(html => {

                let doc = new DOMParser().parseFromString(html, 'text/html');
                let newContent = doc.querySelector('#searchResults');

                if (newContent) {
                    searchResultsWrapper.style.display = 'block';
                    searchResultsWrapper.innerHTML = newContent.innerHTML;

                    // update count + no results
                    let count = newContent.querySelector('.result-count');
                    let noRes = newContent.querySelector('.no-results');

                    if (count) document.querySelector('.result-count').innerHTML = count.innerHTML;
                    if (noRes) document.querySelector('.no-results').outerHTML = noRes.outerHTML;
                }

            });

    }, 300);
});



// INPUT EVENT
mobileSeatchInput.addEventListener('input', function () {
    let searchTerm = this.value.trim();
    clearTimeout(debounceTimer);

    if (searchTerm.length < 1) {
        searchResultsWrapperMobile.style.display = 'none';
        return;
    }

    debounceTimer = setTimeout(() => {

        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[options][fields]=title,body,product_type,variants.title,vendor,variants.sku&resources[limit]=4&section_id=predictive-search`)
            .then(res => res.text())
            .then(html => {

                let doc = new DOMParser().parseFromString(html, 'text/html');
                let newContent = doc.querySelector('#searchResults');

                if (newContent) {
                    searchResultsWrapperMobile.style.display = 'block';
                    searchResultsWrapperMobile.innerHTML = newContent.innerHTML;
                    // update count + no results
                    let count = newContent.querySelector('.result-count');
                    let noRes = newContent.querySelector('.no-results');

                    if (count) document.querySelector('.result-count').innerHTML = count.innerHTML;
                    if (noRes) document.querySelector('.no-results').outerHTML = noRes.outerHTML;
                }

            });

    }, 300);
});

document.querySelectorAll('.header-cart.addtocart_main').forEach(icon => {
    icon.addEventListener('click', function (e) {
        window.SLIDECART_UPDATE && window.SLIDECART_UPDATE();
        window.SLIDECART_OPEN && window.SLIDECART_OPEN();
    })
})


// product add to cart code start here

document.querySelectorAll('.product-atc').forEach(btn => {

    btn.addEventListener('click', function (e) {
        e.preventDefault();

        const variantId = this.dataset.varId;

        if (!variantId) {
            console.error('Variant ID missing');
            return;
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        })
            .then(res => res.json())
            .then(data => {
                window.SLIDECART_UPDATE && window.SLIDECART_UPDATE();
                window.SLIDECART_OPEN && window.SLIDECART_OPEN();

                fetch('/cart.js')
                    .then(res => res.json())
                    .then(cart => {
                        const count = cart.item_count;
                        document.querySelector('.header-icons.desktop-only .cart-item-count').innerHTML = count;
                        document.querySelector('.mobile-right .cart-item-count').innerHTML = count;
                    })
                    .catch(err => console.error('Cart count error:', err));


            })
            .catch(err => {
                console.error('Error:', err);
            });

    });

});

// product add to cart code end here


// wishlist button code for product card

// Swym Custom Wishlist Buttons

(function () {
    // 1. IMPROVED: Count function that verifies the REAL item list length
    function updateWishlistCount() {
        if (!window._swat || typeof window._swat.fetch !== 'function') return;
        // bypass fetchWishlistCount as it often returns cached "1" counts
        window._swat.fetch(function (items) {
            const actualCount = (items && Array.isArray(items)) ? items.length : 0;
            const countEl = document.querySelector('.header-icons.desktop-only .swym-wishlist-count');
            const countE2 = document.querySelector('.mobile-left .swym-wishlist-count');

            if (countEl) {
                countEl.textContent = actualCount;
                countEl.style.display = actualCount > 0 ? 'flex' : 'none';
            }
            if (countE2) {
                countE2.textContent = actualCount;
                countE2.style.display = actualCount > 0 ? 'flex' : 'none';
            }
        });
    }

    // 2. Main Logic to fill hearts and bind clicks
    function initWishlistButtons() {
        const swat = window._swat;

        // Safety check to ensure Swym APIs are fully attached
        if (!swat || typeof swat.fetch !== 'function' || !swat.evtLayer) {
            setTimeout(initWishlistButtons, 300);
            return;
        }

        // --- NEW: Sync with Swym Side Drawer ---
        swat.evtLayer.addEventListener('sw:removedfromwishlist', function (e) {
            const removedVariantId = String(e.detail.d.epi);
            const btn = document.querySelector(`.swym-wishlist-custom-btn[data-variant-id="${removedVariantId}"]`);
            if (btn) {
                btn.classList.remove('swym-wishlisted');
                btn.querySelector('.swym-heart-path')?.setAttribute('fill', 'none');
            }
            // Small delay to allow Swym's internal DB to update before recount
            setTimeout(updateWishlistCount, 600);
        });

        // --- INITIAL LOAD: Set button states ---
        swat.fetch(function (wishlistItems) {
            updateWishlistCount();
            const wishlistedEpis = new Set(wishlistItems.map(item => String(item.epi)));

            document.querySelectorAll('.swym-wishlist-custom-btn').forEach(function (btn) {
                const variantId = String(btn.dataset.variantId);
                const path = btn.querySelector('.swym-heart-path');

                if (wishlistedEpis.has(variantId)) {
                    btn.classList.add('swym-wishlisted');
                    if (path) path.setAttribute('fill', 'currentColor');
                } else {
                    btn.classList.remove('swym-wishlisted');
                    if (path) path.setAttribute('fill', 'none');
                }

                // Prevent multiple event listeners on reload/dynamic load
                if (btn.dataset.swymBound) return;
                btn.dataset.swymBound = 'true';

                btn.addEventListener('click', function (e) {
                    e.preventDefault(); e.stopPropagation();

                    const productData = {
                        empi: parseInt(btn.dataset.productId),
                        epi: parseInt(btn.dataset.variantId),
                        du: btn.dataset.productUrl,
                        iu: btn.dataset.productImg,
                        dt: btn.dataset.productTitle
                    };

                    if (btn.classList.contains('swym-wishlisted')) {
                        swat.removeFromWishList(productData, function () {
                            btn.classList.remove('swym-wishlisted');
                            if (path) path.setAttribute('fill', 'none');
                            updateWishlistCount();
                        });
                    } else {
                        swat.addToWishList(productData, function () {
                            btn.classList.add('swym-wishlisted');
                            if (path) path.setAttribute('fill', 'currentColor');
                            updateWishlistCount();
                        });
                    }
                });
            });
        });
    }

    // Official entry point to ensure Swym is ready
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(initWishlistButtons);


    // document.addEventListener('DOMContentLoaded', () => {

    //     initCollectionFilters();

    // });

    // function initCollectionFilters() {

    //     const filterWrapper = document.querySelector('.eq-collection-filter .eq-collection-filter-value');

    //     if (!filterWrapper) return;

    //     /*
    //     =========================
    //     FILTER CHECKBOXES
    //     =========================
    //     */

    //     const filterInputs = filterWrapper.querySelectorAll(
    //         'input[type="checkbox"]'
    //     );

    //     filterInputs.forEach((input) => {

    //         input.addEventListener('change', () => {
    //             applyCollectionFilters();
    //         });

    //     });

    //     /*
    //     =========================
    //     SORTING
    //     =========================
    //     */

    //     // const sortSelect = document.getElementById('SortBy');

    //     // if (sortSelect) {

    //     //     sortSelect.addEventListener('change', () => {
    //     //     applyCollectionFilters();
    //     //     });

    //     // }

    //     /*
    //     =========================
    //     PRICE RANGE
    //     =========================
    //     */

    //     console.log('Price range init', document.getElementById('fromSlider').value);
    //     // const fromSlider = document.getElementById('fromSlider');
    //     // const toSlider = document.getElementById('toSlider');

    //     // if (fromSlider && toSlider) {

    //     //     fromSlider.addEventListener('change', () => {
    //     //     applyCollectionFilters();
    //     //     });

    //     //     toSlider.addEventListener('change', () => {
    //     //     applyCollectionFilters();
    //     //     });

    //     // }

    //     // const $fromSlider = $("#fromSlider");
    //     // const $toSlider = $("#toSlider");
    //     // const $fromTooltip = $("#fromSliderTooltip");
    //     // const $toTooltip = $("#toSliderTooltip");
    //     // let from = parseInt($fromSlider.val());
    //     // let to = parseInt($toSlider.val());

    //     // if (from > to) {
    //     //     let temp = from;
    //     //     from = to;
    //     //     to = temp;
    //     // }

    //     // const min = parseInt($fromSlider.attr("min"));
    //     // const max = parseInt($fromSlider.attr("max"));

    //     // const percentFrom = ((from - min) / (max - min)) * 100;
    //     // const percentTo = ((to - min) / (max - min)) * 100;

    //     // // Fill position
    //     // // Create fill element
    //     //     const $fill = $("<div class='range-fill'></div>");
    //     //     $(".sliders_control").append($fill);
    //     // $fill.css({
    //     //     left: percentFrom + "%",
    //     //     width: (percentTo - percentFrom) + "%"
    //     // });

    //     // // Tooltips
    //     // $fromTooltip.html(`$${from}`);
    //     // $toTooltip.html(`$${to}`);

    //     // $fromTooltip.css("left", percentFrom + "%");
    //     // $toTooltip.css("left", percentTo + "%");

    //     const clearButton = document.getElementById('ClearAllFilters');

    //     // if (!clearButton) return;

    //     clearButton.addEventListener('click', async (e) => {

    //         e.preventDefault();
    //         console.log('clled clear')
    //         /*
    //         =========================
    //         CLEAN URL
    //         =========================
    //         */

    //         const cleanUrl = window.location.pathname;

    //         try {

    //             document.body.classList.add('loading');

    //             const response = await fetch(cleanUrl);

    //             const responseText = await response.text();

    //             const html = new DOMParser().parseFromString(
    //                 responseText,
    //                 'text/html'
    //             );

    //             /*
    //             =========================
    //             REPLACE SECTION
    //             =========================
    //             */

    //             const newCollectionSection =
    //                 html.querySelector('.eq-collection-filter');

    //             if (newCollectionSection) {

    //                 document.querySelector('.eq-collection-filter').innerHTML =
    //                     newCollectionSection.innerHTML;

    //             }

    //             /*
    //             =========================
    //             UPDATE URL
    //             =========================
    //             */

    //             window.history.pushState(
    //                 {},
    //                 '',
    //                 cleanUrl
    //             );

    //             /*
    //             =========================
    //             REINIT
    //             =========================
    //             */

    //             initCollectionFilters();
    //             //   initClearFilters();

    //         } catch (error) {

    //             console.log(error);

    //         } finally {

    //             document.body.classList.remove('loading');

    //         }

    //     });


    // }

    // async function applyCollectionFilters() {
    //     console.log('called apply filters')
    //     const filterWrapper = document.querySelector('.eq-collection-filter');

    //     if (!filterWrapper) return;

    //     const params = new URLSearchParams();

    //     /*
    //     =========================
    //     CHECKBOX FILTERS
    //     =========================
    //     */

    //     const checkedInputs = filterWrapper.querySelectorAll(
    //         'input[type="checkbox"]:checked'
    //     );

    //     checkedInputs.forEach((input) => {

    //         params.append(
    //             input.name,
    //             input.value
    //         );

    //     });

    //     /*
    //     =========================
    //     PRICE FILTER
    //     =========================
    //     */

    //     //   const minPriceInput = document.getElementById('minPriceInput');
    //     //   const maxPriceInput = document.getElementById('maxPriceInput');

    //     //   if (minPriceInput && minPriceInput.value !== '') {

    //     //     params.append(
    //     //       minPriceInput.name,
    //     //       minPriceInput.value
    //     //     );

    //     //   }

    //     //   if (maxPriceInput && maxPriceInput.value !== '') {

    //     //     params.append(
    //     //       maxPriceInput.name,
    //     //       maxPriceInput.value
    //     //     );

    //     //   }

    //     /*
    //     =========================
    //     SORTING
    //     =========================
    //     */

    //     // const sortSelect = document.getElementById('SortBy');

    //     // if (sortSelect && sortSelect.value !== '') {

    //     //     params.append(
    //     //     'sort_by',
    //     //     sortSelect.value
    //     //     );

    //     // }

    //     /*
    //     =========================
    //     FINAL URL
    //     =========================
    //     */

    //     const collectionUrl =
    //         `${window.location.pathname}?${params.toString()}`;

    //     const activeSortValue = $(".dropdown__select-option.active").data("value");
    //     /*
    //     Example:
    //     /collections/all?
    //     filter.p.t.category=aa-1-1-1&
    //     filter.v.option.size=Small&
    //     filter.p.product_type=SeaDrift+Pants&
    //     sort_by=title-ascending
    //     */

    //     try {

    //         document.body.classList.add('loading');

    //         const response = await fetch(collectionUrl);

    //         const responseText = await response.text();

    //         const html = new DOMParser().parseFromString(
    //             responseText,
    //             'text/html'
    //         );

    //         /*
    //         =========================
    //         REPLACE ENTIRE SECTION
    //         =========================
    //         */

    //         const newFilterSection =
    //             html.querySelector('.eq-collection-filter');

    //         if (newFilterSection) {

    //             document.querySelector('.eq-collection-filter').innerHTML =
    //                 newFilterSection.innerHTML;

    //         }

    //         /*
    //         =========================
    //         UPDATE URL
    //         =========================
    //         */

    //         window.history.pushState(
    //             {},
    //             '',
    //             collectionUrl
    //         );

    //         /*
    //         =========================
    //         RE-INIT EVENTS
    //         =========================
    //         */
    //         initCollectionFilters();
    //         console.log('activeSortValue', activeSortValue);
    //         // sortByFun();
    //         // $(".dropdown__select-option.active").click();
    //         setTimeout(() => {

    //             $(".dropdown__select-option[data-value='" + activeSortValue + "']").click();
    //         }, 100);

    //     } catch (error) {

    //         console.log('Collection filter error:', error);

    //     } finally {

    //         document.body.classList.remove('loading');

    //     }

    //     sortByFun();
    // }

    // function sortByFun() {
    //     const $dropdown = $(".eq-collection-prod-filter");
    //     const $switchInput = $dropdown.find(".dropdown__switch");

    //     // Close dropdown on outside click
    //     $(document).on("click", function (e) {
    //         if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
    //             $switchInput.prop("checked", false);
    //         }
    //     });

    //     const $collectionSelected = $(".dropdown__filter-selected");
    //     const $sortBySelect = $("#SortBy");
    //     const $customOptions = $(".dropdown__select-option");
    //     const $collectionWrapper = $(".eq-collection-filter");
    //     const $productGridContainer = $("#ProductGridContainer");

    //     if ($sortBySelect.length && $collectionSelected.length && $switchInput.length) {

    //         // Set default active option
    //         const currentValue = $sortBySelect.val();
    //         const $activeOption = $customOptions.filter(function () {
    //             return $(this).data("value") == currentValue;
    //         });

    //         if ($activeOption.length) {
    //             $customOptions.removeClass("active");
    //             $activeOption.addClass("active");
    //             $collectionSelected.text($activeOption.text());
    //         }

    //         // Option click
    //         $customOptions.on("click", function () {
    //             const value = $(this).data("value");

    //             $sortBySelect.val(value).trigger("change");
    //             $collectionSelected.text($(this).text());

    //             $customOptions.removeClass("active");
    //             $(this).addClass("active");

    //             console.log('value ', value);

    //             // -----------------------------------
    //             // Build URL with dynamic sort value
    //             // -----------------------------------
    //             let currentUrl = window.location.pathname;
    //             let searchParams = new URLSearchParams(window.location.search);

    //             // Set sort_by dynamically
    //             searchParams.set("sort_by", value);

    //             // Final URL
    //             const finalUrl = `${currentUrl}?${searchParams.toString()}`;

    //             console.log("Final URL:", finalUrl);

    //             // -----------------------------------
    //             // AJAX Replace Collection
    //             // -----------------------------------
    //             $.ajax({
    //                 url: finalUrl,
    //                 type: "GET",
    //                 success: function (response) {

    //                     // Get updated collection HTML
    //                     const newHtml = $(response).find("#ProductGridContainer").html();
    //                     const sortSelectedValue = $(response).find("#SortBy").val();
    //                     console.log('sortSelectedValue ', sortSelectedValue);

    //                     setTimeout(function () {
    //                         window.history.pushState({}, '', finalUrl); $sortBySelect.val(value).trigger("change");
    //                         $productGridContainer.html(newHtml);
    //                         $sortBySelect.val(sortSelectedValue).trigger("change");
    //                         $collectionSelected.text($(this).text());
    //                     }, 100);

    //                     // Optional:
    //                     // Update browser URL without reload

    //                 },
    //                 error: function (xhr, status, error) {
    //                     console.log("Sort Error:", error);
    //                 }
    //             });

    //         });

    //         // Close dropdown after change
    //         $sortBySelect.on("change", function () {
    //             console.log('value ');
    //             setTimeout(function () {
    //                 $switchInput.prop("checked", false);
    //             }, 0);
    //         });

    //         // Extra safety: close if clicked outside generic dropdown
    //         $(document).on("click", function (e) {
    //             const $genericDropdown = $(".dropdown");
    //             if ($genericDropdown.length && !$genericDropdown.is(e.target) && $genericDropdown.has(e.target).length === 0) {
    //                 $switchInput.prop("checked", false);
    //             }
    //             console.log('value 1');
    //             // sortByFun();
    //         });
    //     }
    // }
    // /*
    // =========================
    // BROWSER BACK/FORWARD
    // =========================
    // */

    // // window.addEventListener('popstate', async () => {
    // //     console.log('popstate')

    // // const response = await fetch(window.location.href);

    // // const responseText = await response.text();

    // // const html = new DOMParser().parseFromString(
    // //     responseText,
    // //     'text/html'
    // // );

    // // const newFilterSection =
    // //     html.querySelector('.eq-collection-filter');

    // // if (newFilterSection) {

    // //     document.querySelector('.eq-collection-filter').innerHTML =
    // //     newFilterSection.innerHTML;


    // // const clearBtn = document.getElementById('ClearAllFilters');

    // // if (!clearBtn) return;

    // // clearBtn.addEventListener('click', async (e) => {

    // //     e.preventDefault();
    // //     console.log('clled clear')
    // //     /*
    // //     =========================
    // //     CLEAN URL
    // //     =========================
    // //     */

    // //     const cleanUrl = window.location.pathname;

    // //     try {

    // //     document.body.classList.add('loading');

    // //     const response = await fetch(cleanUrl);

    // //     const responseText = await response.text();

    // //     const html = new DOMParser().parseFromString(
    // //         responseText,
    // //         'text/html'
    // //     );

    // //     /*
    // //     =========================
    // //     REPLACE SECTION
    // //     =========================
    // //     */

    // //     const newCollectionSection =
    // //         html.querySelector('.eq-collection-filter');

    // //     if (newCollectionSection) {

    // //         document.querySelector('.eq-collection-filter').innerHTML =
    // //         newCollectionSection.innerHTML;

    // //     }

    // //     /*
    // //     =========================
    // //     UPDATE URL
    // //     =========================
    // //     */

    // //     window.history.pushState(
    // //         {},
    // //         '',
    // //         cleanUrl
    // //     );

    // //     /*
    // //     =========================
    // //     REINIT
    // //     =========================
    // //     */

    // //     initCollectionFilters();
    // //     //   initClearFilters();

    // //     } catch(error) {

    // //     console.log(error);

    // //     } finally {

    // //     document.body.classList.remove('loading');

    // //     }

    // // });

    // // }

    // // initCollectionFilters();


    // // });

    // sortByFun();
    // // ==========================
    // // COLLECTION TAB CLICK 
    // // ==========================
    // //    $(".eq-collection__category a").on("click", function (e) {
    // //        e.preventDefault();

    // //        let category = $(this).data("category");

    // //        // Active tab
    // //        $(".eq-collection__category a").removeClass("active");
    // //        $(this).addClass("active");

    // //        // Show correct content
    // //        $(".eq-product__sub").removeClass("active").hide();
    // //        $('.eq-product__sub[data-category="' + category + '"]')
    // //            .addClass("active")
    // //            .fadeIn(200);

    // //         // $('#ClearAllFilters').click();
    // //    });

    MatchHeight();

})();
